import styled from "styled-components";
import { MainTemplate } from "../../templates/MainTemplate";
import { useHome } from "./hook";

export const HomePage: React.FC = () => {
  const { showNotRegister } = useHome();

  return (
    <MainTemplate title="" useFitHeight>
      {showNotRegister && (
        <StyledCenterContainer>表示する権限がありません</StyledCenterContainer>
      )}
    </MainTemplate>
  );
};

const StyledCenterContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  font-weight: 700;
  font-size: 24px;
`;
